import React from 'react';
import PropTypes from 'prop-types';

import InputContainer from './InputContainer';

const FormInputContainer = ({ meta, children, ...props }) => (
  <InputContainer {...props} error={meta && meta.touched && meta.error}>
    {children}
  </InputContainer>
);

FormInputContainer.defaultProps = {
  meta: null
};

FormInputContainer.propTypes = {
  meta: PropTypes.shape({
    label: PropTypes.string,
    touched: PropTypes.bool,
    error: PropTypes.any
  }),
  children: PropTypes.node.isRequired
};

export default FormInputContainer;
